// App.js
import React, { useEffect, lazy, Suspense } from 'react';
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux"; // Importa o useDispatch
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { themeSettings } from "theme";
import { setUserType, setOrgaoId } from './service/orgaoSlice'; // Importa as ações do orgaoSlice
import ProtectedRoute from 'components/ProtectedRoute';
import SessionValidator from 'components/SessionValidator';
import PageSkeleton from 'components/PageSkeleton';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles.css';

const Layout = lazy(() => import("pages/layout"));
const Dashboard = lazy(() => import("pages/dashboard"));
const AutosInfracao = lazy(() => import("pages/Autos/autos_infração"));
const ImpressaoAuto = lazy(() => import("pages/Autos/impressao_auto"));
const DetalhesInfracao = lazy(() => import("pages/Autos/detalhes_infracao"));
const DetalhesInfracaoEstrangeiro = lazy(() => import("pages/Autos/detalhes_infracao_estrangeiro"));
const DetalhesAutuacaoPfPj = lazy(() => import("pages/Autos/detalhes_autuacao_pfpj"));
const LoginForm = lazy(() => import("./pages/login/Form"));
const GestaoHabiltacoes = lazy(() => import("pages/Gerenciamentos/gestão_habilitações"));
const GestaoVeiculos = lazy(() => import("pages/Gerenciamentos/gestão_veiculos"));
const GestaoUsuarios = lazy(() => import("pages/Gerenciamentos/gestão_usuarios"));
const NovoUsuario = lazy(() => import("pages/Gerenciamentos/gest\u00e3o_usuarios/NovoUsuario"));
const EditarUsuario = lazy(() => import("pages/Gerenciamentos/gest\u00e3o_usuarios/EditarUsuario"));
const GestaoDispositivos = lazy(() => import("pages/Equipamentos/dispositivos"));
const NovoSmartphone = lazy(() => import("pages/Equipamentos/dispositivos/NovoSmartphone"));
const EditarSmartphone = lazy(() => import("pages/Equipamentos/dispositivos/EditarSmartphone"));
const MonitoramentoDispositivos = lazy(() => import("pages/Equipamentos/Monitoramentos/MonitoramentoDispositivos"));
const GestaoEquipamentos = lazy(() => import("pages/Equipamentos/equipamentos_afericao"));
const NovoEquipamento = lazy(() => import("pages/Equipamentos/equipamentos_afericao/NovoEquipamento"));
const EditarEquipamento = lazy(() => import("pages/Equipamentos/equipamentos_afericao/EditarEquipamento"));
const Grvs = lazy(() => import("pages/Grvs"));
const SinaisNotorios = lazy(() => import("pages/Sinais_Notorios"));
const AguardandoCancelamento = lazy(() => import("./pages/Cancelamentos/aguardando_cancelamento"));
const EnvioAutos = lazy(() => import("pages/EnvioAutos"));  
const EnvioAutosAlcoolemia = lazy(() => import("pages/envio-autos-alcoolemia"));
const EnvioAutosSemAlcoolemia = lazy(() => import("pages/envio-autos-sem-alcoolemia"));
const MedidasAdministrativas = lazy(() => import("pages/medidas_administrativas"));
const AdicionarFaixa = lazy(() => import("./pages/Faixa-Infracoes/adicionar_faixa"));
const InventarioEstoque = lazy(() => import("pages/Equipamentos/estoque"));
const NovaMovimentacaoEstoque = lazy(() => import("pages/Equipamentos/estoque/NovaMovimentacao"));
const EditarMovimentacaoEstoque = lazy(() => import("pages/Equipamentos/estoque/EditarMovimentacao"));
const ListarFaixas = lazy(() => import("./pages/Faixa-Infracoes/listar_faixas"));
const ReservaFaixaDispositivo = lazy(() => import("./pages/Faixa-Infracoes/reserva-taloes"));
const IncidenciaInfracoes = lazy(() => import("./pages/graficos/incidencia_infracoes"));
const TotalInfracoesMes = lazy(() => import("./pages/graficos/total_infracoes_mes"));
const TotalInfracoesAgentes = lazy(() => import("./pages/graficos/total_infracoes_agentes"));
const RankingInfracoes = lazy(() => import("./pages/graficos/ranking_infracoes"));
const InfracoesCanceladas = lazy(() => import("./pages/graficos/infracoes_canceladas"));
const AutosLocalizacao = lazy(() => import("./pages/graficos/autos_localizacao"));
const ReincidenciasList = lazy(() => import("./pages/Reincidencias/lista_reincidencias"));
const ReincidenciasRevisadas = lazy(() => import("./pages/Reincidencias/reincidencias_revisadas"));
const ReincidenciasPermitidas = lazy(() => import("./pages/Reincidencias/reincidencias_permitidas"));
const GestaoClientes = lazy(() => import("./pages/Gerenciamentos/GestaoClientesOrgaos"));
const AutosInfracaoSemVeiculo = lazy(() => import("pages/Autos/autos_sem_veiculo"));
const LogsAcesso = lazy(() => import("pages/logs/logs_acesso"));
const SimCartaoList = lazy(() => import("pages/Equipamentos/chips"));
const NovoChip = lazy(() => import("pages/Equipamentos/chips/NovoChip"));
const EditarChip = lazy(() => import("pages/Equipamentos/chips/EditarChip"));
const GestaoImpressoras = lazy(() => import("pages/Equipamentos/impressoras"));
const NovaImpressora = lazy(() => import("pages/Equipamentos/impressoras/NovaImpressora"));
const EditarImpressora = lazy(() => import("pages/Equipamentos/impressoras/EditarImpressora"));
const AutoErroList = lazy(() => import("pages/logs/autos-Erro"));
const DetalhesGrv = lazy(() => import('pages/Grvs/detalhesGrv'));
const DetalhesSinaisNotorios = lazy(() => import('pages/Sinais_Notorios/detalhesSinaisNotorios'));
const GestaoOrgaos = lazy(() => import('pages/Gerenciamentos/gestão_orgãos'));
const GestaoEscalas = lazy(() => import('pages/Gerenciamentos/gestão_escalas_agentes'));
const LogsPlantao = lazy(() => import('pages/logs/logs-escalas'));
const Avisos = lazy(() => import('pages/avisos'));
const NovoAviso = lazy(() => import('pages/avisos/NovoAviso'));
const Chamados = lazy(() => import('pages/Chamados'));
const SimuladorAgente = lazy(() => import('pages/Chamados/SimuladorAgente'));
const LogsApis = lazy(() => import('pages/logs/logs_apis'));
const ConsultasCnhCpf = lazy(() => import('pages/Consultas/Consultas-cnh-cpf'));
const ConsultasDetran = lazy(() => import('pages/Consultas/Consultas-detran'));
const LogsInfracoes = lazy(() => import("./pages/logs/logs-auto-transporte"));
const GestaoNotificacoes = lazy(() => import('pages/notificacoes'));
const NovaNotificacao = lazy(() => import('pages/notificacoes/NovaNotificacao'));
const HistoricoNotificacao = lazy(() => import('pages/notificacoes/HistoricoNotificacao'));
const GestaoDuvidasFrequentes = lazy(() => import('pages/faq'));
const NovoArtigo = lazy(() => import('pages/faq/NovoArtigo'));
const EditarArtigo = lazy(() => import('pages/faq/EditarArtigo'));
const NovaDuvida = lazy(() => import('pages/faq/NovaDuvida'));
const EditarDuvida = lazy(() => import('pages/faq/EditarDuvida'));
const RelatorioDiario = lazy(() => import('pages/relatorios/diario'));
const RelatorioTotalizador = lazy(() => import('pages/relatorios/totalizador'));
const RelatorioDetalhados = lazy(() => import('pages/relatorios/detalhados'));
const EditarCliente = lazy(() => import('pages/Gerenciamentos/GestaoClientesOrgaos/EditarCliente'));
const CriarCliente = lazy(() => import('pages/Gerenciamentos/GestaoClientesOrgaos/CriarCliente'));
const CriarOrgao = lazy(() => import('pages/Gerenciamentos/GestaoClientesOrgaos/CriarOrgao'));
const EditarOrgao = lazy(() => import('pages/Gerenciamentos/GestaoClientesOrgaos/EditarOrgao'));
const CriarUnidade = lazy(() => import('pages/Gerenciamentos/GestaoClientesOrgaos/CriarUnidade'));
const EditarUnidade = lazy(() => import('pages/Gerenciamentos/GestaoClientesOrgaos/EditarUnidade'));
const OperacoesEscalas = lazy(() => import('pages/OperacoesEscalas'));
const NovoTipoOperacao = lazy(() => import('pages/OperacoesEscalas/NovoTipoOperacao'));
const EditarTipoOperacao = lazy(() => import('pages/OperacoesEscalas/EditarTipoOperacao'));
const BasesSistema = lazy(() => import('pages/BasesSistema'));
const CriarVeiculoEmbarcado = lazy(() => import('pages/BasesSistema/CriarVeiculoEmbarcado'));
const EditarVeiculoEmbarcado = lazy(() => import('pages/BasesSistema/EditarVeiculoEmbarcado'));
const CriarCondutorEmbarcado = lazy(() => import('pages/BasesSistema/CriarCondutorEmbarcado'));
const EditarCondutorEmbarcado = lazy(() => import('pages/BasesSistema/EditarCondutorEmbarcado'));
const CriarInfracaoEmbarcada = lazy(() => import('pages/BasesSistema/CriarInfracaoEmbarcada'));
const EditarInfracaoEmbarcada = lazy(() => import('pages/BasesSistema/EditarInfracaoEmbarcada'));
const MonitoramentoChat = lazy(() => import('pages/Chat'));
const GruposListagem = lazy(() => import('pages/Grupos'));
const GrupoAcessos = lazy(() => import('pages/Grupos/GrupoAcessos'));
const EditarGrupo = lazy(() => import('pages/Grupos/EditarGrupo'));
const OutrosRegistros = lazy(() => import('pages/OutrosRegistros'));
const DetalhesOutrosRegistrosGrv = lazy(() => import('pages/OutrosRegistros/DetalhesGrv'));
const DetalhesOutrosRegistrosGrd = lazy(() => import('pages/OutrosRegistros/DetalhesGrd'));
const DetalhesOutrosRegistrosMedidaAdministrativa = lazy(() => import('pages/OutrosRegistros/DetalhesMedidaAdministrativa'));
const DetalhesTermoSinaisNotorios = lazy(() => import('pages/OutrosRegistros/DetalhesSinaisNotorios'));
const VeiculoAbandonado = lazy(() => import('pages/OutrosRegistros/VeiculoAbandonado'));
const DetalhesVeiculoAbandonado = lazy(() => import('pages/OutrosRegistros/DetalhesVeiculoAbandonado'));
const ImpressaoVeiculoAbandonado = lazy(() => import('pages/OutrosRegistros/ImpressaoVeiculoAbandonado'));
const DetalhesBoletimSinistro = lazy(() => import('pages/OutrosRegistros/DetalhesBoletimSinistro'));

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Restaura o isAdmin e o orgaoId do localStorage ao carregar a aplicação
    const orgaoId = localStorage.getItem('selected_orgao_id');
    const isAdmin = localStorage.getItem('isAdmin') === 'true'; // Recupera o isAdmin do localStorage

    // Despacha as ações para restaurar os valores no Redux
    dispatch(setUserType({ isAdmin, orgaoId: isAdmin ? null : orgaoId }));
    dispatch(setOrgaoId(orgaoId));
  }, [dispatch]);

  const mode = useSelector((state) => state.global.mode);
  const theme = useMemo(() => createTheme(themeSettings("light")), ["light"]);

  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Suspense fallback={<PageSkeleton />}>
            <Routes>
              <Route path="/" element={<LoginForm />} />
               <Route path="/impressao-auto/:id" element={<ImpressaoAuto />} />
               <Route path="/outros-registros/veiculo-abandonado/imprimir/:id" element={<ImpressaoVeiculoAbandonado />} />
              <Route element={<ProtectedRoute><SessionValidator><Layout /></SessionValidator></ProtectedRoute>}>
                <Route
                  path="/dashboard"
                  element={<Dashboard />}
                />
                <Route
                  path="/bases-sistema"
                  element={<BasesSistema />}
                />
                <Route
                  path="/bases-sistema/veiculos"
                  element={<BasesSistema />}
                />
                <Route
                  path="/bases-sistema/condutores"
                  element={<BasesSistema />}
                />
                <Route
                  path="/bases-sistema/veiculos/novo"
                  element={<CriarVeiculoEmbarcado />}
                />
                <Route
                  path="/bases-sistema/veiculos/editar/:id"
                  element={<EditarVeiculoEmbarcado />}
                />
                <Route
                  path="/bases-sistema/condutores/novo"
                  element={<CriarCondutorEmbarcado />}
                />
                <Route
                  path="/bases-sistema/condutores/editar/:id"
                  element={<EditarCondutorEmbarcado />}
                />
                <Route
                  path="/bases-sistema/infracoes/novo"
                  element={<CriarInfracaoEmbarcada />}
                />
                <Route
                  path="/bases-sistema/infracoes/editar/:id"
                  element={<EditarInfracaoEmbarcada />}
                />
                <Route
                  path="/auto-infracoes"
                  element={<AutosInfracao />}
                />
                <Route
                  path="/auto-infracao-erro"
                  element={<AutoErroList />}
                />
                <Route path="/chamados" element={<Chamados />} />
                <Route path="/chamados/simulador-agente" element={<SimuladorAgente />} />
                <Route path="/chamados/novos" element={<Chamados />} />
                <Route path="/chamados/analise" element={<Chamados />} />
                <Route path="/chamados/resolvido" element={<Chamados />} />
                <Route
                  path="/notificacoes"
                  element={<GestaoNotificacoes />}
                />
                <Route
                  path="/notificacoes/nova"
                  element={<NovaNotificacao />}
                />
                <Route
                  path="/notificacoes/editar/:id"
                  element={<NovaNotificacao />}
                />
                <Route
                  path="/notificacoes/historico/:id"
                  element={<HistoricoNotificacao />}
                />
                <Route
                  path="/faq"
                  element={<GestaoDuvidasFrequentes />}
                />
                <Route
                  path="/faq/perguntas"
                  element={<GestaoDuvidasFrequentes />}
                />
                <Route
                  path="/faq/artigos"
                  element={<NovaDuvida />}
                />
                <Route
                  path="/faq/artigos/novo"
                  element={<NovoArtigo />}
                />
                <Route
                  path="/faq/artigos/editar/:id"
                  element={<EditarArtigo />}
                />
                <Route
                  path="/faq/perguntas/editar/:id"
                  element={<EditarDuvida />}
                />
                <Route
                  path="/faq/novo-artigo"
                  element={<NovoArtigo />}
                />
                <Route
                  path="/logs-sistema"
                  element={<LogsAcesso />}
                />
                <Route
                  path="/logs-sistema/:tab"
                  element={<LogsAcesso />}
                />
                <Route
                  path="logs-auto-transporte"
                  element={<LogsInfracoes />}
                />
                <Route
                  path="/logs-apis"
                  element={<LogsApis />}
                />
                <Route
                  path="/medidas"
                  element={<MedidasAdministrativas />}
                />
                <Route
                  path="/aguardando-cancelamento"
                  element={<AguardandoCancelamento />}
                />
                <Route
                  path="/detalhes-infracao/:id"
                  element={<DetalhesInfracao />}
                />
                <Route
                  path="/detalhes-infracao-estrangeiro/:id"
                  element={<DetalhesInfracaoEstrangeiro />}
                />
                <Route
                  path="/detalhes-autuacao-pfpj/:id"
                  element={<DetalhesAutuacaoPfPj />}
                />
                {/* <Route path="/autos-cancelados" element={<AutosCancelado />} /> */}
                <Route
                  path="/envio-autos"
                  element={<EnvioAutos />}
                />
                <Route
                  path="/envio-autos/pendentes"
                  element={<EnvioAutos />}
                />
                <Route
                  path="/envio-autos/envio_detran"
                  element={<EnvioAutos />}
                />
                <Route
                  path="/envio-autos/enviados"
                  element={<EnvioAutos />}
                />
                <Route
                  path="/envio-autos/baixar_imagens"
                  element={<EnvioAutos />}
                />
                <Route
                  path="/envio-autos-alcoolimia"
                  element={<EnvioAutos />}
                />
                <Route
                  path="/envio-autos-sem-alcoolimia"
                  element={<EnvioAutos />}
                />
                <Route
                  path="/auto-infracoes-sem-veiculo"
                  element={<AutosInfracaoSemVeiculo />}
                />
                <Route
                  path="/escalas"
                  element={<GestaoEscalas />}
                />
                <Route
                  path="/logs-plantao"
                  element={<LogsPlantao />}
                />
                <Route
                  path="/consultas-detran"
                  element={<ConsultasDetran />}
                />
                <Route
                  path="/consultas-cnh-cpf"
                  element={<ConsultasCnhCpf />}
                />
                <Route
                  path="/usuarios"
                  element={<GestaoUsuarios />}
                />
                <Route
                  path="/usuarios/novo"
                  element={<NovoUsuario />}
                />
                <Route
                  path="/usuarios/editar/:id"
                  element={<EditarUsuario />}
                />
                <Route
                  path="/habilitacoes"
                  element={<GestaoHabiltacoes />}
                />
                <Route
                  path="/veiculos"
                  element={<GestaoVeiculos />}
                />
                <Route
                  path="/dispositivos"
                  element={<GestaoDispositivos />}
                />
                <Route
                  path="/dispositivos/novo"
                  element={<NovoSmartphone />}
                />
                <Route
                  path="/dispositivos/editar/:id"
                  element={<EditarSmartphone />}
                />
                <Route
                  path="/equipamentos"
                  element={<GestaoEquipamentos />}
                />
                <Route
                  path="/equipamentos/novo"
                  element={<NovoEquipamento />}
                />
                <Route
                  path="/equipamentos/editar/:id"
                  element={<EditarEquipamento />}
                />
                <Route
                  path="/grvs"
                  element={<Grvs />}
                />
                <Route
                  path="/detalhes-grv/:id"
                  element={<DetalhesGrv />}
                />
                <Route
                  path="/sinais-notorios"
                  element={<SinaisNotorios />}
                />
                <Route
                  path="/detalhes-sinais-notorios/:id"
                  element={<DetalhesSinaisNotorios />}
                />
                <Route
                  path="/impressoras"
                  element={<GestaoImpressoras />}
                />
                <Route
                  path="/impressoras/nova"
                  element={<NovaImpressora />}
                />
                <Route
                  path="/impressoras/editar/:id"
                  element={<EditarImpressora />}
                />
                <Route
                  path="/adicionar-faixa"
                  element={<AdicionarFaixa />}
                />
                <Route
                  path="/liberar-faixa"
                  element={<Navigate to="/estoque" replace />}
                />
                <Route
                  path="/estoque"
                  element={<InventarioEstoque />}
                />
                <Route
                  path="/liberar-faixa/nova"
                  element={<Navigate to="/estoque/nova" replace />}
                />
                <Route
                  path="/estoque/nova"
                  element={<NovaMovimentacaoEstoque />}
                />
                <Route
                  path="/liberar-faixa/editar/:id"
                  element={<EditarMovimentacaoEstoque />}
                />
                <Route
                  path="/estoque/editar/:id"
                  element={<EditarMovimentacaoEstoque />}
                />
                <Route
                  path="/listar-faixas"
                  element={<ListarFaixas />}
                />
                <Route
                  path="/faixa-infracoes/distribuicao"
                  element={<ReservaFaixaDispositivo />}
                />
                <Route path="/analises">
                  <Route path="recorrentes" element={<IncidenciaInfracoes />} />
                  <Route path="top10" element={<RankingInfracoes />} />
                  <Route path="mensal" element={<TotalInfracoesMes />} />
                  <Route path="produtividade" element={<TotalInfracoesAgentes />} />
                  <Route path="canceladas" element={<InfracoesCanceladas />} />
                  <Route path="georreferenciado" element={<AutosLocalizacao />} />
                </Route>
                <Route
                  path="/reincidencias"
                  element={<ReincidenciasList />}
                />
                <Route
                  path="/avisos"
                  element={<Avisos />} />
                <Route
                  path="/avisos/novo"
                  element={<NovoAviso />} />
                <Route
                  path="/avisos/editar/:id"
                  element={<NovoAviso />} />
                <Route
                  path="/reincidencias-revisadas"
                  element={<ReincidenciasRevisadas />}
                />
                <Route
                  path="/reincidencias-permitidas"
                  element={<ReincidenciasPermitidas />}
                />
                <Route
                  path="/relatorios"
                  element={<RelatorioDiario />}
                />
                <Route
                  path="/relatorios/diario"
                  element={<RelatorioDiario />}
                />
                <Route
                  path="/relatorios/totalizador"
                  element={<RelatorioTotalizador />}
                />
                <Route
                  path="/relatorios/detalhados"
                  element={<RelatorioDetalhados />}
                />
                <Route path="/chips" element={<SimCartaoList />} />
                <Route path="/chips/novo" element={<NovoChip />} />
                <Route path="/chips/editar/:id" element={<EditarChip />} />
                <Route path="/clientes" element={<GestaoClientes />} />
                <Route path="/clientes/novo" element={<CriarCliente />} />
                <Route path="/clientes/editar/:id" element={<EditarCliente />} />
                <Route path="/orgaos" element={<GestaoOrgaos />} />
                <Route path="/orgaos/novo" element={<CriarOrgao />} />
                <Route path="/orgaos/editar/:id" element={<EditarOrgao />} />
                <Route path="/unidades/novo" element={<CriarUnidade />} />
                <Route path="/unidades/editar/:id" element={<EditarUnidade />} />
                <Route path="/operacoes-escalas" element={<OperacoesEscalas />} />
                <Route path="/operacoes-escalas/tipos/novo" element={<NovoTipoOperacao />} />
                <Route path="/operacoes-escalas/tipos/editar/:id" element={<EditarTipoOperacao />} />
                <Route path="/dispositivos/monitoramento" element={<MonitoramentoDispositivos />} />
                <Route path="/chat-ia" element={<MonitoramentoChat />} />
                <Route path="/grupos" element={<GruposListagem />} />
                <Route path="/grupos/acessos" element={<GruposListagem />} />
                <Route path="/grupos/permissoes" element={<GruposListagem />} />
                <Route path="/grupos/editar/:id" element={<EditarGrupo />} />
                <Route path="/grupos/permissoes/:id" element={<GrupoAcessos />} />
                <Route path="/outros-registros" element={<OutrosRegistros />} />
                <Route path="/outros-registros/grv" element={<OutrosRegistros />} />
                <Route path="/outros-registros/grv/:id" element={<DetalhesOutrosRegistrosGrv />} />
                <Route path="/outros-registros/grd" element={<OutrosRegistros />} />
                <Route path="/outros-registros/grd/:id" element={<DetalhesOutrosRegistrosGrd />} />
                <Route path="/outros-registros/medida-adm" element={<OutrosRegistros />} />
                <Route path="/outros-registros/medida-adm/:id" element={<DetalhesOutrosRegistrosMedidaAdministrativa />} />
                <Route path="/outros-registros/sinais-notorios" element={<OutrosRegistros />} />
                <Route path="/outros-registros/sinais-notorios/:id" element={<DetalhesTermoSinaisNotorios />} />
                <Route path="/outros-registros/veiculo-abandonado" element={<VeiculoAbandonado />} />
                <Route path="/outros-registros/veiculo-abandonado/:id" element={<DetalhesVeiculoAbandonado />} />
                <Route path="/outros-registros/boletim-acidente" element={<OutrosRegistros />} />
                <Route path="/outros-registros/boletim-acidente/:id" element={<DetalhesBoletimSinistro />} />
                <Route path="/outros-registros/vistoria" element={<OutrosRegistros />} />
              </Route>
            </Routes>
          </Suspense>
        </ThemeProvider>
      </BrowserRouter>
      <ToastContainer position="top-right" autoClose={4000} />
    </div>
  );
}

export default App;
